/**
 * Kalkulationslogik – Stülpdeckelbox
 *
 * WICHTIG: Diese Datei ist die EINZIGE Quelle der Preislogik für diesen Boxtyp.
 * Sie wird unverändert sowohl im Theme (Browser, für die Live-Vorschau) als auch
 * im Backend (PHP, für die verbindliche Preisberechnung beim Bestellen)
 * eingesetzt. Nach einer Änderung an dieser Datei IMMER auch
 * backend-php/private/lib/calculators/stuelpdeckelbox.php von Hand nachziehen
 * (siehe Kommentar dort) – das Sync-Skript kopiert nur die JS-Variante.
 *
 * Stand 28.07.2026 (erneut überarbeitet, nach Kundenrückmeldung):
 *   Maße (Mindestmaß Länge/Breite: 30 mm)
 *   -> Bezugspapier: Auswahl Naturpapier ODER 4C gedruckt
 *        Naturpapier -> zusätzlich Farbauswahl (Wibalin Natural)
 *        4C gedruckt -> ersetzt das Naturpapier (kein Farbfeld), Druckbogen
 *                       70×100 cm, Preis pro Bogen gestaffelt nach Gesamtauflage
 *   -> Material (Innenseite): Grau / Weiß / Schwarz (Innen-Kaschierung nur auf
 *      Anfrage, kein Preisfeld hier)
 *   -> Veredelung Ja/Nein (= Logoprägung, inkl. Klischeegröße)
 *
 * Datei-Uploads gibt es an dieser Stelle bewusst NICHT mehr: Der Kunde kann
 * Druckdaten erst anlegen, sobald er den Aufriss der Box erhalten hat – das
 * passiert im weiteren Projektverlauf, nicht schon in diesem Formular.
 *
 * 4C gedruckt (als Bezugsmaterial): Der bedruckbare Bogen ist immer 70×100 cm
 * groß. Es wird berechnet, wie viele Bögen für Unterteil + Deckel der
 * GESAMTEN Bestellung benötigt werden (aufgerundet auf ganze Bögen je Teil),
 * und danach der Preis pro Bogen anhand der Gesamt-Bogenzahl gestaffelt:
 *   bis 10 Bögen   7,00 € / Bogen
 *   bis 50 Bögen   3,00 € / Bogen
 *   bis 100 Bögen  2,00 € / Bogen
 *   bis 200 Bögen  1,80 € / Bogen
 *   über 200 Bögen vorläufig ebenfalls 1,80 € / Bogen (vom Kunden noch nicht
 *   genannt – bei Bedarf mit Erfurt Etuis abstimmen)
 *
 * Preisübersicht: Alle Preise in dieser Datei sind NETTO-Preise. Für die
 * Anzeige (Preisübersicht/Überblick im Konfigurator) wird zusätzlich die
 * MwSt. (19 %, siehe VAT_RATE) sowie der Brutto-Preis mitgeliefert.
 *
 * ACHTUNG – ein offener Platzhalter, mit Tobi/Kunde noch final zu klären:
 *   1. Karton-Preis für "Grau" (Graupappe): aktuell weiterhin auf 1050×800mm,
 *      2,60 € gesetzt (alter "Karton Weiß"-Wert), bis ein eigener Preis
 *      vorliegt. "Weiß" (2,60 €) und "Schwarz" (3,30 €) sind bereits die
 *      echten, vom Kunden genannten Werte.
 *
 * Vertrag:
 *   calculate(inputs) -> Ergebnisobjekt mit { valid, note, ...Detailfeldern }
 *   inputs = {
 *     innerLength: number (mm, mind. 30),
 *     innerWidth:  number (mm, mind. 30),
 *     baseHeight:  number (mm),
 *     lidHeight:   number (mm),
 *     qty:         number (Stück, ganzzahlig, >= 1),
 *
 *     bezugspapierAuswahl:   'naturpapier' | 'druck4c'    // immer Pflicht
 *     bezugspapierFarbe:     string, z. B. 'WBN500'       // nur bei 'naturpapier'
 *     bezugspapierFarbeName: string                       // nur bei 'naturpapier'
 *     materialInnen:         'grau' | 'weiss' | 'schwarz' // immer Pflicht
 *
 *     veredelung:  boolean,                        // Ja/Nein = Logoprägung
 *     clicheSize:  'A7' | 'A6' | 'A5' | 'A4' | ''   // nur wenn veredelung === true
 *   }
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.BoxCalculators = root.BoxCalculators || {};
    root.BoxCalculators.stuelpdeckelbox = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Mindestmaß für Innenmaß Länge/Breite (Kundenvorgabe).
  var MIN_INNER_SIZE = 30;

  // -- Karton (strukturelle Pappe, zeigt sich auf der Innenseite) ----------
  var KARTON_OPTIONS = {
    grau: {
      // Platzhalter, siehe Datei-Kopf Punkt 1.
      name: 'Grau',
      sheetLength: 1050,
      sheetWidth: 800,
      sheetPrice: 2.60
    },
    weiss: {
      name: 'Weiß',
      sheetLength: 1050,
      sheetWidth: 800,
      sheetPrice: 2.60
    },
    schwarz: {
      name: 'Schwarz',
      sheetLength: 1100,
      sheetWidth: 700,
      sheetPrice: 3.30
    }
  };
  var DEFAULT_MATERIAL_INNEN = 'grau';

  // -- Bezugsmaterial, Option 1: Naturpapier (Wibalin Natural) -------------
  var COVER = {
    name: 'Naturpapier Wibalin',
    sheetLength: 1020,
    sheetWidth: 760,
    sheetPrice: 2.15,
    wrapAllowance: 15
  };

  // Fallback, falls trotz Pflichtfeld keine Farbe übermittelt wird.
  var DEFAULT_COVER_COLOR_SKU = 'WBN500';
  var DEFAULT_COVER_COLOR_NAME = 'White';

  // -- Bezugsmaterial, Option 2: 4C gedruckt -------------------------------
  // Bedruckbarer Bogen, immer 70 × 100 cm (= 700 × 1000 mm). Ersetzt bei
  // Auswahl das Naturpapier (keine zusätzliche Wibalin-Lage/Kosten).
  var DRUCK4C_SHEET = {
    sheetLength: 1000,
    sheetWidth: 700,
    wrapAllowance: 15 // gleiche Annahme wie beim Naturpapier (umlaufender Rand)
  };

  // Preis pro Bogen, gestaffelt nach der GESAMT-Bogenzahl der Bestellung
  // (Unterteil + Deckel zusammen). Siehe Datei-Kopf für Details/Quelle.
  var DRUCK4C_PRICE_TIERS = [
    { maxSheets: 10, price: 7.00 },
    { maxSheets: 50, price: 3.00 },
    { maxSheets: 100, price: 2.00 },
    { maxSheets: 200, price: 1.80 }
  ];
  // Für Bestellungen über 200 Bögen liegt noch kein Preis vor – vorläufig
  // wird der günstigste bekannte Preis (1,80 €) weiterverwendet.
  var DRUCK4C_PRICE_ABOVE_MAX_TIER = 1.80;

  function getDruck4cPricePerSheet(totalSheets) {
    for (var i = 0; i < DRUCK4C_PRICE_TIERS.length; i++) {
      if (totalSheets <= DRUCK4C_PRICE_TIERS[i].maxSheets) {
        return DRUCK4C_PRICE_TIERS[i].price;
      }
    }
    return DRUCK4C_PRICE_ABOVE_MAX_TIER;
  }

  var SETUP_FEE = 100;

  // -- Veredelung: Logoprägung ----------------------------------------------
  var EMBOSSING_BASE = 0.30;
  var EMBOSSING_SETUP = 30;
  var CLICHE_PRICES = {
    A7: 60,
    A6: 80,
    A5: 110,
    A4: 160
  };

  // Deutsche Mehrwertsteuer, nur für die Anzeige (netto/brutto) relevant –
  // alle übrigen Preise in dieser Datei sind Netto-Preise.
  var VAT_RATE = 0.19;

  function num(value) {
    return Math.max(parseFloat(value || 0), 0);
  }

  // Rundet auf volle Cent (kaufmännisch).
  function round2(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  function floorFit(sheetLength, sheetWidth, itemLength, itemWidth) {
    if (itemLength <= 0 || itemWidth <= 0) return 0;
    var normal = Math.floor(sheetLength / itemLength) * Math.floor(sheetWidth / itemWidth);
    var rotated = Math.floor(sheetLength / itemWidth) * Math.floor(sheetWidth / itemLength);
    return Math.max(normal, rotated);
  }

  function getProductionTier(maxSide) {
    if (maxSide <= 80) return { name: 'Sehr klein', price: 5.80 };
    if (maxSide <= 150) return { name: 'Klein', price: 6.60 };
    if (maxSide <= 250) return { name: 'Mittel', price: 9.60 };
    return { name: 'Groß', price: 14.00 };
  }

  function getOpenBase(length, width, baseHeight) {
    return {
      length: length + (2 * baseHeight),
      width: width + (2 * baseHeight)
    };
  }

  function getOpenLid(length, width, lidHeight) {
    return {
      length: length + 5 + (2 * lidHeight),
      width: width + 5 + (2 * lidHeight)
    };
  }

  // Offene Fläche für die äußere Kaschierung (Naturpapier ODER 4C-Druck) –
  // beide nehmen denselben umlaufenden Rand an (siehe COVER/DRUCK4C_SHEET
  // wrapAllowance, aktuell identisch).
  function getOpenCover(length, width, height, wrapAllowance) {
    return {
      length: length + (2 * height) + (2 * wrapAllowance),
      width: width + (2 * height) + (2 * wrapAllowance)
    };
  }

  function calculate(inputs) {
    inputs = inputs || {};

    var innerLength = num(inputs.innerLength);
    var innerWidth = num(inputs.innerWidth);
    var baseHeight = num(inputs.baseHeight);
    var lidHeight = num(inputs.lidHeight);
    var qty = Math.max(parseInt(inputs.qty || 1, 10) || 1, 1);

    var materialInnenKey = KARTON_OPTIONS.hasOwnProperty(inputs.materialInnen) ? inputs.materialInnen : DEFAULT_MATERIAL_INNEN;
    var karton = KARTON_OPTIONS[materialInnenKey];

    var bezugspapierAuswahl = inputs.bezugspapierAuswahl === 'druck4c' ? 'druck4c' : 'naturpapier';
    var bezugspapierFarbeSku = (inputs.bezugspapierFarbe || '').trim();
    var bezugspapierFarbeName = (inputs.bezugspapierFarbeName || '').trim();

    var veredelung = Boolean(inputs.veredelung);
    var clicheSize = inputs.clicheSize || '';

    var result = {
      valid: false,
      note: 'Bitte geben Sie Ihre Maße ein, um eine Orientierungskalkulation zu erhalten.'
    };

    if (!innerLength || !innerWidth || !baseHeight || !lidHeight) {
      return result;
    }

    if (innerLength < MIN_INNER_SIZE || innerWidth < MIN_INNER_SIZE) {
      result.note = 'Innenmaß Länge und Breite müssen jeweils mindestens ' + MIN_INNER_SIZE + ' mm betragen.';
      return result;
    }

    if (lidHeight < 15) {
      result.note = 'Die Höhe des Deckels muss mindestens 15 mm betragen.';
      return result;
    }

    if (veredelung && (!clicheSize || !CLICHE_PRICES.hasOwnProperty(clicheSize))) {
      result.note = 'Bitte wählen Sie eine Klischeegröße aus.';
      return result;
    }

    var embossingFormatNotice = (veredelung && (innerLength > 280 || innerWidth > 190))
      ? ' Hinweis: Die maximale Prägefläche beträgt 280 × 190 mm. Bitte prüfen Sie, ob das Motiv innerhalb dieser Fläche liegt.'
      : '';

    var openBase = getOpenBase(innerLength, innerWidth, baseHeight);
    var openLid = getOpenLid(innerLength, innerWidth, lidHeight);

    var cartonBaseUnits = floorFit(karton.sheetLength, karton.sheetWidth, openBase.length, openBase.width);
    var cartonLidUnits = floorFit(karton.sheetLength, karton.sheetWidth, openLid.length, openLid.width);

    if (!cartonBaseUnits || !cartonLidUnits) {
      result.note = 'Das offene Format ist in dieser Größe aktuell nicht kalkulierbar. Bitte prüfen Sie Ihre Maße.';
      return result;
    }

    var cartonCostPerPiece =
      (karton.sheetPrice / cartonBaseUnits) +
      (karton.sheetPrice / cartonLidUnits);

    // -- Bezugsmaterial: Naturpapier ODER 4C gedruckt (schließen sich aus) --
    var coverBaseUnits = null;
    var coverLidUnits = null;
    var coverCostPerPiece = 0;
    var coverColorName = '';
    var druck4cTotalSheets = null;
    var druck4cPricePerSheet = null;

    if (bezugspapierAuswahl === 'druck4c') {
      var openPrintBase = getOpenCover(innerLength, innerWidth, baseHeight, DRUCK4C_SHEET.wrapAllowance);
      var openPrintLid = getOpenCover(innerLength + 5, innerWidth + 5, lidHeight, DRUCK4C_SHEET.wrapAllowance);

      var druck4cBaseUnitsPerSheet = floorFit(DRUCK4C_SHEET.sheetLength, DRUCK4C_SHEET.sheetWidth, openPrintBase.length, openPrintBase.width);
      var druck4cLidUnitsPerSheet = floorFit(DRUCK4C_SHEET.sheetLength, DRUCK4C_SHEET.sheetWidth, openPrintLid.length, openPrintLid.width);

      if (!druck4cBaseUnitsPerSheet || !druck4cLidUnitsPerSheet) {
        result.note = 'Das offene Format ist für den Druckbogen (70 × 100 cm) aktuell nicht kalkulierbar. Bitte prüfen Sie Ihre Maße.';
        return result;
      }

      druck4cTotalSheets = Math.ceil(qty / druck4cBaseUnitsPerSheet) + Math.ceil(qty / druck4cLidUnitsPerSheet);
      druck4cPricePerSheet = getDruck4cPricePerSheet(druck4cTotalSheets);

      coverCostPerPiece = (druck4cTotalSheets * druck4cPricePerSheet) / qty;
      coverColorName = '4C gedruckt (Druckdaten folgen im weiteren Projektverlauf)';
      bezugspapierFarbeSku = '';
    } else {
      var openCoverBase = getOpenCover(innerLength, innerWidth, baseHeight, COVER.wrapAllowance);
      var openCoverLid = getOpenCover(innerLength + 5, innerWidth + 5, lidHeight, COVER.wrapAllowance);

      coverBaseUnits = floorFit(COVER.sheetLength, COVER.sheetWidth, openCoverBase.length, openCoverBase.width);
      coverLidUnits = floorFit(COVER.sheetLength, COVER.sheetWidth, openCoverLid.length, openCoverLid.width);

      if (!coverBaseUnits || !coverLidUnits) {
        result.note = 'Das offene Format ist in dieser Größe aktuell nicht kalkulierbar. Bitte prüfen Sie Ihre Maße.';
        return result;
      }

      coverCostPerPiece =
        (COVER.sheetPrice / coverBaseUnits) +
        (COVER.sheetPrice / coverLidUnits);

      coverColorName = bezugspapierFarbeName || bezugspapierFarbeSku || DEFAULT_COVER_COLOR_NAME;
      if (!bezugspapierFarbeSku) {
        bezugspapierFarbeSku = DEFAULT_COVER_COLOR_SKU;
      }
    }

    var productionTier = getProductionTier(Math.max(innerLength, innerWidth, baseHeight, lidHeight));
    var setupPerPiece = SETUP_FEE / qty;

    var veredelungPerPiece = 0;
    var veredelungNote = 'Ohne Veredelung';

    if (veredelung) {
      var clicheCost = CLICHE_PRICES[clicheSize] || 0;
      veredelungPerPiece = EMBOSSING_BASE + (EMBOSSING_SETUP / qty) + (clicheCost / qty);
      veredelungNote = 'Logoprägung inkl. Klischee ' + clicheSize;
    }

    var totalPerPiece =
      cartonCostPerPiece +
      coverCostPerPiece +
      productionTier.price +
      setupPerPiece +
      veredelungPerPiece;

    var total = totalPerPiece * qty;

    // WICHTIG (Rundungskonsistenz Checkout): "total" oben ist der ungerundete
    // Rohwert (nur zur Anzeige, wo er ohnehin auf 2 Nachkommastellen formatiert
    // wird). "totalRounded" ist der EINMALIG gerundete Gesamtpreis und genau
    // der Betrag, der im Backend als Draft-Order-Zeilenpreis an Shopify
    // übergeben wird (siehe draft-order.php: quantity 1, price totalRounded).
    // Würde man stattdessen z. B. den Stückpreis runden und dann mit der
    // Menge multiplizieren, könnte der Checkout-Betrag höher ausfallen als
    // der hier angezeigte Gesamtpreis (aufgerundeter Stückpreis × Menge) –
    // genau das darf laut Kundenvorgabe nicht passieren.
    var totalRounded = round2(total);

    // Netto ist die Kalkulationsgrundlage; für die Anzeige zusätzlich MwSt./Brutto.
    var totalPerPieceVat = totalPerPiece * VAT_RATE;
    var totalPerPieceGross = totalPerPiece + totalPerPieceVat;
    var totalVat = total * VAT_RATE;
    var totalGross = total + totalVat;

    return {
      valid: true,
      note: 'Unser Produktionsteam wählt je nach Anforderungen eigenständig die Dicke des Kartons aus.' + embossingFormatNotice,

      innerLength: innerLength,
      innerWidth: innerWidth,
      baseHeight: baseHeight,
      lidHeight: lidHeight,
      qty: qty,

      materialInnen: materialInnenKey,
      materialName: karton.name,

      bezugspapierAuswahl: bezugspapierAuswahl,
      bezugspapierFarbeSku: bezugspapierFarbeSku,
      bezugspapierFarbeName: coverColorName,

      veredelung: veredelung,
      veredelungNote: veredelungNote,
      clicheSize: veredelung ? clicheSize : '',
      druck4cTotalSheets: druck4cTotalSheets,
      druck4cPricePerSheet: druck4cPricePerSheet,

      openBase: openBase,
      openLid: openLid,

      cartonBaseUnits: cartonBaseUnits,
      cartonLidUnits: cartonLidUnits,
      coverBaseUnits: coverBaseUnits,
      coverLidUnits: coverLidUnits,

      cartonCostPerPiece: cartonCostPerPiece,
      coverCostPerPiece: coverCostPerPiece,
      productionTier: productionTier,
      setupPerPiece: setupPerPiece,
      veredelungPerPiece: veredelungPerPiece,

      totalPerPiece: totalPerPiece,
      total: total,
      totalRounded: totalRounded,

      vatRate: VAT_RATE,
      totalPerPieceVat: totalPerPieceVat,
      totalPerPieceGross: totalPerPieceGross,
      totalVat: totalVat,
      totalGross: totalGross
    };
  }

  /**
   * Liefert die Konfiguration als flache Liste von Label/Wert-Paaren, wie sie
   * als Line-Item-Properties auf der Shopify-Bestellung erscheinen sollen.
   * Wird sowohl vom Backend (Draft Order) als auch optional vom Frontend
   * genutzt, damit Anzeige und Bestellung immer exakt übereinstimmen.
   *
   * Sichtbarkeit: Property-Namen, die mit einem Unterstrich ("_") beginnen,
   * werden von Shopify automatisch als "hidden properties" behandelt – sie
   * erscheinen NICHT im Warenkorb, Checkout, in der Bestellbestätigungs-Mail
   * oder im Kundenkonto, sind aber ganz normal auf der Bestellung im Shopify
   * Admin (und über die Admin-API) sichtbar. Genau darüber laufen hier alle
   * rein internen/technischen Kalkulationsdetails (offene Formate, Bogen-
   * nutzen, Fertigungskategorie, Preis-Zwischenschritte) – für den Kunden
   * bleiben nur seine eigenen Auswahl-/Konfigurationsangaben sowie der
   * verbindliche Gesamtpreis sichtbar.
   */
  function describe(calc, extra) {
    if (!calc || !calc.valid) return {};

    var props = {
      'Stückzahl': calc.qty + ' Stück',
      'Innenmaß (L × B)': calc.innerLength + ' × ' + calc.innerWidth + ' mm',
      'Höhe Unterteil': calc.baseHeight + ' mm',
      'Höhe Deckel': calc.lidHeight + ' mm',
      'Bezugspapier': calc.bezugspapierAuswahl === 'druck4c'
        ? '4C gedruckt'
        : ('Naturpapier – ' + calc.bezugspapierFarbeName + (calc.bezugspapierFarbeSku ? ' (' + calc.bezugspapierFarbeSku + ')' : '')),
      'Material (Innenseite)': calc.materialName,
      'Veredelung': calc.veredelungNote
    };

    if (calc.clicheSize) {
      props['Klischeegröße'] = calc.clicheSize;
    }

    // -- Ab hier: rein interne/technische Angaben, nur für Admin/Produktion
    //    (Property-Name beginnt bewusst mit "_", siehe Kommentar oben). --
    if (calc.druck4cTotalSheets) {
      props['_Druckbögen (70×100 cm)'] = calc.druck4cTotalSheets + ' Stück à ' + calc.druck4cPricePerSheet.toFixed(2).replace('.', ',') + ' €';
    }

    props['_Offenes Maß Unterteil'] = calc.openBase.length + ' × ' + calc.openBase.width + ' mm';
    props['_Offenes Maß Deckel'] = calc.openLid.length + ' × ' + calc.openLid.width + ' mm';
    props['_Nutzen Karton (Unterteil/Deckel)'] = calc.cartonBaseUnits + ' / ' + calc.cartonLidUnits;

    if (calc.bezugspapierAuswahl === 'naturpapier') {
      props['_Nutzen Naturpapier (Unterteil/Deckel)'] = calc.coverBaseUnits + ' / ' + calc.coverLidUnits;
    }

    props['_Fertigungskategorie'] = calc.productionTier.name;
    props['_Preis pro Stück (netto, rechnerisch)'] = calc.totalPerPiece.toFixed(2).replace('.', ',') + ' €';
    props['_MwSt. (' + Math.round(calc.vatRate * 100) + ' %) pro Stück'] = calc.totalPerPieceVat.toFixed(2).replace('.', ',') + ' €';
    props['_Preis pro Stück (brutto)'] = calc.totalPerPieceGross.toFixed(2).replace('.', ',') + ' €';

    // Der verbindliche Gesamtpreis bleibt für den Kunden sichtbar (kein "_").
    props['Gesamtpreis (netto, verbindlich)'] = calc.totalRounded.toFixed(2).replace('.', ',') + ' €';

    if (extra && extra.notes) {
      props['Sonderwünsche'] = extra.notes;
    }

    return props;
  }

  return {
    calculate: calculate,
    describe: describe,
    materials: { KARTON_OPTIONS: KARTON_OPTIONS, COVER: COVER },
    CLICHE_PRICES: CLICHE_PRICES,
    VAT_RATE: VAT_RATE
  };
});
